{
  "rangeOverflow": "Стойността трябва да е {maxValue} или по-ранна.",
  "rangeReversed": "Началната дата трябва да е преди крайната.",
  "rangeUnderflow": "Стойността трябва да е {minValue} или по-късно.",
  "unavailableDate": "Избраната дата не е налична."
}
